import { IUser } from '../models/user.model';
import { request } from './base';

function signIn(email: string, password: string) {
  return request<{
    tokens: {
      access_token: string;
      refresh_token: string;
    };
    user: IUser;
  }>({
    url: '/auth/sign-in',
    method: 'POST',
    data: { email, password },
  });
}

const authApi = Object.freeze({
  signIn,
});

export default authApi;
